/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sizeText: NonNullable<unknown> }} Workout_Logging_Plate_KgInputs */

const en_us2_workout_logging_plate_kg = /** @type {(inputs: Workout_Logging_Plate_KgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sizeText}`)
};

const pt_br2_workout_logging_plate_kg = /** @type {(inputs: Workout_Logging_Plate_KgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sizeText}`)
};

const es_419_workout_logging_plate_kg = /** @type {(inputs: Workout_Logging_Plate_KgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sizeText}`)
};

const pt_pt2_workout_logging_plate_kg = /** @type {(inputs: Workout_Logging_Plate_KgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sizeText}`)
};

const fr_fr2_workout_logging_plate_kg = /** @type {(inputs: Workout_Logging_Plate_KgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sizeText}`)
};

const de_de2_workout_logging_plate_kg = /** @type {(inputs: Workout_Logging_Plate_KgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sizeText}`)
};

const it_it2_workout_logging_plate_kg = /** @type {(inputs: Workout_Logging_Plate_KgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sizeText}`)
};

/**
* | output |
* | --- |
* | "{sizeText}" |
*
* @param {Workout_Logging_Plate_KgInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_plate_kg = /** @type {((inputs: Workout_Logging_Plate_KgInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Plate_KgInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_plate_kg(inputs)
	if (locale === "es-419") return es_419_workout_logging_plate_kg(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_plate_kg(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_plate_kg(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_plate_kg(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_plate_kg(inputs)
	return en_us2_workout_logging_plate_kg(inputs)
});
export { workout_logging_plate_kg as "workout-logging.plate_kg" }